
import React, { useState } from 'react'
import { Stack, Typography, styled } from '@mui/material';
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import ScrollBox from './ScrollBox';
import { formatName, formatUserType, getReqTimelineStyle, isEmpty, isNotEmpty } from '../utils/format';
import { timelineItemClasses } from '@mui/lab/TimelineItem';

function ProdReqTimeline({ dataArr }) {
    const DottedConnector = styled(TimelineConnector)(({ theme }) => ({
        backgroundImage: "linear-gradient(to bottom, black 25%, rgba(255, 255, 255, 0.6) 25%)",
        backgroundSize: "15px 10px",
        backgroundRepeat: "repeat-y",
        width: "1px",
    }));

    const [visibleItemId, setVisibleItemId] = useState(null);
    const handleShowMore = (id) => {
        setVisibleItemId((prevId) => (prevId === id ? null : id));
    };

    return (
        <ScrollBox >

            <Timeline sx={{
                [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                },
            }}>
                {dataArr.map((i) => {
                    const { color, bycolor, icon, status } = getReqTimelineStyle(i?.status);
                    return <TimelineItem key={i?.id}>
                        <TimelineSeparator sx={{ mt: 0 }}>
                            <TimelineDot sx={{ backgroundColor: `${color}`, marginBottom: 1 }} />
                            {['created', 'approved',  'edited'].includes(i?.status) && <DottedConnector />}
                        </TimelineSeparator>
                        <TimelineContent sx={{ mt: 1, width: "100%" }}>
                            <Stack direction={"row"} width={"100%"}>
                                <img src={icon} alt='icons' style={{ width: 20, height: 15 }} />
                                <Stack direction={"column"} width={'100%'} >
                                    <Stack direction={"row"} width={'100%'} alignItems="center" justifyContent="space-between">
                                        <Stack direction={"column"} sx={{ ml: 2 }}>
                                            <Typography sx={{ borderColor: "rgb(0,0,0,0.1)", fontSize: 11, fontWeight: 500 }}>{`${status} - ${formatUserType(i?.statusLevel)}`}</Typography>
                                            <Typography sx={{
                                                backgroundColor: bycolor, borderRadius: 1, fontSize: 10, fontWeight: 400,
                                                marginRight: "auto", px: 1
                                            }}>By {`${formatName(i?.cByFName, i?.cByLName)}`}</Typography>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} sx={{ marginTop: 1, marginRight: 1, ml: 2, width: "100%" }}>
                                        <Typography sx={{ borderColor: "rgb(0,0,0,0.1)", fontSize: 11, fontWeight: 700, }}>Notes:&nbsp;&nbsp;</Typography>
                                        <Typography sx={{
                                            borderColor: "rgb(0,0,0,0.1)", fontSize: 11, fontWeight: 300, width: "82%",
                                            wordWrap: "break-word",
                                            whiteSpace: "pre-wrap"
                                        }}>
                                            {isEmpty(i?.remarks) ? "NA" : (visibleItemId === i?.id ? `${i?.remarks}` : `${(i?.remarks || '').substring(0, 50)}`)}
                                            {(isNotEmpty(i?.remarks) && (i?.remarks || "").length > 50) &&
                                                <button style={{ border: 'none', color: "rgb(155,15,238,238)", fontSize: 10 }}
                                                    onClick={() => handleShowMore(i?.id)} >
                                                    {visibleItemId === i?.id ? "Show less" : "More..."} </button>}
                                        </Typography>
                                    </Stack>
                                </Stack>

                            </Stack>
                        </TimelineContent>
                    </TimelineItem>
                })}
            </Timeline>

        </ScrollBox>
    );
}
export default ProdReqTimeline;


